<script>
import { tick } from 'svelte';
import EventExpand from "./EventExpand.svelte";
import EventExpandSvg from "./EventExpandSvg.svelte";
  export let ev;
  export let sw = false;
  //Öppen från början
  export let open = true;
  export let k;

  export let toggleExpanded;
  export let flagFile;
  export let participants = [];
  export let svgFile = "2026-02-04_19-05.svg";
  export let expandLocked = false;



  // C = visa fakla (men INTE svensk styling/expand)
$: isCeremony = String(ev?.svensk_event ?? "").trim().toUpperCase() === "C";

$: isPossibly = String(ev?.svensk_event ?? "").trim().toUpperCase() === "E";





  const formatKanal = (s) => s.replace(/_/g, " ");



  function showType(type) {
  const t = String(type ?? "").trim().toUpperCase();

  if (t === "H") return "<span> (H)</span>";
  if (t === "D") return "<span> (D)</span>";
  return "";
  }


  // --- LÅS UX ---
  let lockShake = false;
  let lockSound;
  let showPop = false;

  // om du vill: initiera ljudet bara en gång
  function ensureLockSound() {
    if (lockSound) return;
    // byt filnamn om du vill (.mp3/.wav)
    lockSound = new Audio("./local_assets/os2026/lock/lock2.mp3");
    lockSound.preload = "auto";
    lockSound.volume = 0.7;
  }

  async function showLocked() {
    // skaka bara om lås-ikonen finns (du renderar den bara när sw && expandLocked)
    if (!(sw && expandLocked)) return;

    // 1) Shake (resetta så den alltid triggar även vid snabba klick)
    lockShake = false;
    showPop = false;
    await tick();
    lockShake = true;
    showPop = true;

    // ta bort klassen efter animationen så den kan triggas igen
    window.setTimeout(() => {
      lockShake = false;
    }, 650);


    window.setTimeout(() => {
      showPop = false;
    }, 2650);

    // 2) Ljud
    try {
      ensureLockSound();
      lockSound.currentTime = 0;
      await lockSound.play();
    } catch (e) {
      // Autoplay-policy kan blocka ibland; då får man bara shake.
    }
  }

  function onRowActivate(e) {
    console.log(isPossibly);
    // Enter/Space på div -> förhindra scroll/side effects
    if (e?.type === "keydown") {
      const key = e.key;
      if (key !== "Enter" && key !== " ") return;
      e.preventDefault();
    }
    if (isCeremony) return;
    if (isPossibly) return;

    if (expandLocked) {
      showLocked();
      return;
    }
    toggleExpanded(k);
  }

</script>

<div class="event-row" 
class:is-svensk={sw} 
class:is-open={open} 
class:is-poss={isPossibly} 
role="listitem"  

on:click={onRowActivate}
on:keydown={onRowActivate}>





<div class="event-body-wrapper">
  
  <div class="event-time">
    <div class="event-time-wrapper">{ev.klockslag}</div>
  </div>

  <div class="event-body">
    <div class="event-top">
      <div class="event-top-left">
        <div class="event-sport">{ev.sport}{@html showType(ev.typ)}</div>
      </div>
    </div>

    {#if ev.info}
      <div class="event-info">{ev.info}</div>
    {/if}

    {#if ev.lag1 || ev.lag2}
      <div class="event-teams">
        {#if ev.lag1}
          <div class="team-row">
            {#if ev.lag1 !== "ej klart"}
            <div class="flagga-wrapper">
              <img
                class="flagga"
                src={`../assets/images/countries/${flagFile(ev.lag1)}.png`}
                alt={ev.lag1}
                on:error={(e) => (e.currentTarget.style.display = "none")}
              />
            </div>
            {/if}
            <span class="team-name">{ev.lag1}</span>
          </div>
        {/if}

        {#if ev.lag2}
          <span class="vs">–</span>
          <div class="team-row">
            {#if ev.lag2 !== "ej klart"}
            <div class="flagga-wrapper">
              <img
                class="flagga"
                src={`../assets/images/countries/${flagFile(ev.lag2)}.png`}
                alt={ev.lag2}
                on:error={(e) => (e.currentTarget.style.display = "none")}
              />
            </div>
            {/if}
            <span class="team-name">{ev.lag2}</span>
          </div>
        {/if}
      </div>

    {/if}
    {#if ev.tv_kanal}
      <div class="event-channels">
          {#each ev.tv_kanal.trim().split(/\s+/) as kanal}
            <div class="tv-kanal">{formatKanal(kanal)}</div>
          {/each}
      </div>    
    {/if}
  </div>
    
  

      {#if sw}

          {#if expandLocked }

          <div class="lock-wrapper" class:is-shaking={lockShake} title="Lås">
            <img class="lock" src="./local_assets/os2026/lock/lock.png" alt="Lås" />
          </div>
          {/if}

        <div class="event-top-right">


          <div class="flagga-wrapper flagga-wrapper--big" title="Svensk höjdpunkt">
            <img class="flagga" src="../assets/images/countries/sverige.png" alt="Sveriges flagga" />
          </div>


        {#if ev.svgfil}
  
          <button
            type="button"
            class="expand-btn"
            aria-expanded={open}
            disabled={expandLocked}
            aria-disabled={expandLocked}
          >
               
        <span>Läs mer</span>
            <span class="chev" aria-hidden="true">
              <svg class="chev-icon" viewBox="0 0 24 24" focusable="false">
                <use href={open ? "#ds-expand_less" : "#ds-expand_more"} />
              </svg>
            </span>
          </button>
        {/if}
        </div>


      {:else if isCeremony}

        <div class="event-top-right">
          <div class="flagga-wrapper flagga-wrapper--big" title="Ceremoni">
            <img
              class="flagga fakla"
              src="./local_assets/os2026/lock/fackla.gif"
              alt="Ceremoni"
              on:error={(e) => (e.currentTarget.style.display = "none")}
            />
          </div>
        </div>
      
        {:else if isPossibly}

        <div class="event-top-right">
          {#if false}
          <div class="flagga-wrapper flagga-wrapper--big" title="Svensk höjdpunkt">
            <img class="flagga" src="../assets/images/countries/sverige.png" alt="Sveriges flagga" />
          </div>
          {/if}
          <span>Möjligt svenskt<br>deltagande</span>
        </div>  
       
      {/if}

</div>
{#if sw && open}

  {#if ev.svgfil}
    <EventExpandSvg svgFile={ev.svgfil} />
  {/if}

{/if}
{#if sw }
  <div class="popup" style={`display:${showPop ? 'flex': 'none' }`}>

<div>Välkommen tillbaka om en vecka. Då låser vi upp hela schemat.</div>
 


  </div>
{/if}


</div>







<style global type="text/scss" lang="scss">


.popup {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  height: 100px;
  background-color: #fff;
  border: 1px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  padding: 1rem;
  box-sizing: border-box;

}

.popup div {
  font-size: 1.6rem;
}


.chev {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.chev-icon {
  width: 32px;
  height: 32px;
  display: block;
  fill: currentColor;     /* tar färg från textfärgen */
}


.lock-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform-origin: 50% 50%;
}

.lock-wrapper.is-shaking {
  animation: lockShake 0.65s linear 1;
}

@keyframes lockShake {
  0%   { transform: translateX(0) rotate(0deg); }
  5%  { transform: translateX(-2px) rotate(-6deg); }
  10%  { transform: translateX(3px) rotate(6deg); }
  15%  { transform: translateX(-3px) rotate(-6deg); }
  20%  { transform: translateX(3px) rotate(6deg); }
  25%  { transform: translateX(-3px) rotate(-6deg); }
  30%  { transform: translateX(3px) rotate(6deg); }
  35%  { transform: translateX(-3px) rotate(-6deg); }
  40%  { transform: translateX(3px) rotate(6deg); }
  45%  { transform: translateX(-3px) rotate(-6deg); }
  50%  { transform: translateX(3px) rotate(6deg); }
  55%  { transform: translateX(-3px) rotate(-6deg); }
  60%  { transform: translateX(3px) rotate(6deg); }
  65%  { transform: translateX(-3px) rotate(-6deg); }
  70%  { transform: translateX(3px) rotate(6deg); }
  75%  { transform: translateX(-3px) rotate(-6deg); }
  80%  { transform: translateX(2px) rotate(4deg); }
  90%  { transform: translateX(-1px) rotate(-2deg); }
  100% { transform: translateX(0) rotate(0deg); }
}


.nedry {
  position: relative;
top: -50px;
  left: 0;
  scale: 70%;
}


.nedry-body {
  position: relative;
  top: 0;
  left: 0;
}

.nedry-head {
  position: absolute;
  top: 5px;
  left: 140px;
}

.nedry-hand{
  position: absolute;
  top: 155px;
  left: 265px;
  animation: handFrames linear 1s;
  animation-iteration-count: infinite;
  transform-origin: 50% 100%;
  -webkit-animation: handFrames linear 0.7s;
  -webkit-animation-iteration-count: infinite;
  -webkit-transform-origin: 50% 100%;
}

@keyframes handFrames{
  0% {
    transform:  rotate(-10deg) ;
  }
  50% {
    transform:  rotate(14deg) ;
  }
  100% {
    transform:  rotate(-10deg) ;
  }
}


.expand-btn {
  appearance: none;
  -webkit-appearance: none;

  color: var(--special-text-color);
  -webkit-text-fill-color: var(--special-text-color); /* iOS-fix */

  background: transparent;
  border: 0;
  padding: 0.2rem 0.6rem;
  cursor: pointer;

  text-decoration: none;
  -webkit-tap-highlight-color: transparent; /* tar bort blå highlight */
}

/* allt inne i knappen ska ärva färgen */
.expand-btn,
.expand-btn * {
  color: inherit;
  -webkit-text-fill-color: var(--special-text-color);
}

/* svg ska ta färg via currentColor */
.expand-btn .chev-icon {
  width: 2rem;
  height: 2rem;
  display: block;
  fill: var(--special-text-color);
  stroke: var(--special-text-color);
}

/* extra: om du nån gång råkar ha <a> inne i knappen */
.expand-btn a {
  color: inherit;
  text-decoration: none;
}




</style>